export default __webpack_public_path__ + "img/dzjVzKYK.cb2d39ea.svg";